import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { alpha, styled } from "@mui/material/styles";
import MenuItem from "@mui/material/MenuItem";
import { Button, TablePagination, Typography, TextField, FormControl, Select, InputLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import Modal from "../Modal";
import Toast from "../../../utils/toast";
import createInstance from "../../../api/axiosinstance";

const aiDishaApi = createInstance("DISHA");
const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#B9B9B9",
  },
  "& label": {
    color: "#FEFEFE",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B9B9B9",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#B9B9B9",
      borderRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: "#B9B9B9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#B9B9B9",
    },
    "& .MuiInputBase-input": {
      color: "#FEFEFE",
    },
  },
}));

const CssFormControl = styled(FormControl)({
  '& label': {
    color: '#FEFEFE',
    '&.Mui-focused': {
      color: '#B9B9B9',
    },
  },
  '& .MuiInputBase-root': {
    // color: '#FF0000',
    color: 'white',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B9B9B9',
      borderRadius: 10,

    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B9B9B9',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#B9B9B9',
    },
  },
});

const CssSelect = styled(Select)({
  '& .MuiSvgIcon-root': {
    color: '#B9B9B9',
    textAlign: "center"
  },
});

const CityManagement = () => {

  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [activeCityList, setActiveCityList] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [deactivateId, setDeactiveId] = useState("");
  const [creationDate] = useState(new Date().toISOString());
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [actionType, setActionType] = useState("");

  useEffect(() => {
    fetchActiveStates();
    fetchActiveCities();
  }, []);

  const fetchActiveStates = async () => {
    try {
      const response = await aiDishaApi.get("/Get_active_states");
      setStates(response.data);
      console.log("state data", response.data);
    } catch (error) {
      console.error("Error fetching active states:", error);
    }
  };

  const fetchDistrictsForState = async (state) => {
    setSelectedState(state);

    try {
      const districtResponse = await aiDishaApi.get(`/fetch_active_district_by_state?statename=${encodeURIComponent(state)}`);
      console.log("Districts data:", districtResponse.data);
      setDistricts(districtResponse.data);

      // Fetch cities for the selected state
      const cityResponse = await aiDishaApi.get(`/filter_cities?state_name=${state}`);
      console.log("Cities API Response:", cityResponse.data);

      if (Array.isArray(cityResponse.data)) {
        setCities(cityResponse.data);
      } else {
        console.error("Unexpected cities data format:", cityResponse.data);
        Toast.error("Error loading cities data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      Toast.error(error.response?.data?.detail || "Failed to load data");
    }
  };

  //Fetch all cities (Active & Inactive) belonging to the selected state
  // const fetchAllCities = async (state) => {
  //   setSelectedState(state);
  //   try {
  //     const response = await aiDishaApi.get(`/filter_cities?state_name=${state}`);
  //     console.log("Cities API Response:", response.data); // Debug log

  //     if (Array.isArray(response.data)) {
  //       setCities(response.data);
  //     } else {
  //       console.error("Unexpected cities data format:", response.data);
  //       Toast.error("Error loading cities data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching cities:", error);
  //     Toast.error("Failed to load cities");
  //   }
  // };

  const fetchActiveCities = async () => {
    await aiDishaApi.get('/Cities/all')
      .then((response) => {
        setActiveCityList(response.data);
        console.log("Active Cities.." + response.data);
      })
      .catch((error) => {
        console.error("Error fetching active cities" + error);
      })
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  const handleModalOpen = (cityId,action) => {
    setDeactiveId(cityId);
    setActionType(action);
    setIsModalOpen(true);
  };

  const handleConfirm = async (cityId) => {
    await handleDeactivateCity(cityId);
    setIsModalOpen(false);
  };
  const handleDeactivateCity = async (cityId, currentStatus) => {
    try {
      const newStatus = currentStatus  === "Active" ? "Inactive" : "Active";
      console.log("******" + cityId + "******");
      const response = await aiDishaApi.patch(
      `/Cities/${cityId}/active-inactive?status=${newStatus}`
    );
      if (response.status === 200) {
        Toast.success("City deactivated successfully");
        fetchActiveCities();
      }
    } catch (error) {
      console.error("Error deactivating city:", error);
      Toast.error("Failed to deactivate city");
    }
  };

  const header = [
    {
      city_id: "City ID",
      city_name: "City Name",
      state_name: "State Name",
      district_name: "District Name",
      creation_date: "Creation Date",
      action: "Action",
    },
  ];

  const paginatedRows = activeCityList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  const handleClear = () => {
    setSelectedState("");
    setSelectedDistrict("");
    setSelectedCity("");
  };

  const handleCitySubmit = async (event) => {
    event.preventDefault();
    try {
      if (!selectedState || !selectedState.trim()) {
        Toast.error("State name cannot be empty");
        return;
      }

      if (!selectedCity) {
        Toast.error("Please select a city");
        return;
      }

      const response = await aiDishaApi.post(`/Cities?state_name=${selectedState}&district=${selectedDistrict}&city=${selectedCity}`,
      {
        Status: "Active", // <-- required body
      });

      if (response.status === 200) {
        Toast.success("City activated successfully");
        handleClear();
        fetchActiveCities();
      }
    } catch (error) {
       Toast.error(`Failed to activate city: ${error.response?.data?.message || error.message}`);
      // console.error("Detailed error information:", {
      //   error: error,
      //   endpoint: `/Cities?state_name=${selectedState}&district=${selectedDistrict}&city=${selectedCity}`,
      //   method: 'POST'

        
      // }
    // );

      // Toast.error(`Failed to activate city: ${error.response?.data?.message || error.message}`);
    }
  };

  return (
    <div>
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "30px",
          alignItems: "center",
          // background: alpha("#B9B9B9", 0.2),
          background: "#033538",
          borderRadius: "10px",
          padding: "15px",
        }}
      >
        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "white" }}
          >
            Add City
          </Typography>
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "16px", color: "white" }}
          >
            Add the Name of the City
          </Typography>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            State Name
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select State</InputLabel>
            <CssSelect
              label="state"
              id="demo-simple-select-outlined"
              size="small"
              value={selectedState}
              onChange={(e) => fetchDistrictsForState(e.target.value)}
              sx={{ width: '100%', textAlign: "center" }}>
              {!states || states.length === 0 ? (
                <MenuItem value="">No states available</MenuItem>
              ) : (
                states.map((state) => (
                  <MenuItem
                    key={state.state_id}
                    value={state.state_name}
                    sx={{ color: '#033538' }} // Make dropdown items visible
                  >
                    {state.state_name}
                  </MenuItem>
                ))
              )}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 2" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }} >
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            Creation Date
          </Typography>
          <CssTextField
            value={creationDate + "(Auto)"}
            InputProps={{
              readOnly: true,
            }}
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "95%" }}
          />
        </Box>
        <Box gridColumn="span 2" sx={{ marginTop: "auto", textAlign: "center", marginBottom: "10px" }}>
          <Button onClick={handleClear}
            sx={{
              border: "1px solid",
              color: "white",
              width: "120px",
              height: "40px",
              borderRadius: "10px",
              fontFamily: "poppins",
            }}
          >
            clear
          </Button>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            District Name
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select District</InputLabel>
            <CssSelect
              label="district"
              id="demo-simple-select-outlined"
              size="small"
              value={selectedDistrict}
              onChange={(e) => setSelectedDistrict(e.target.value)}
              sx={{ width: '100%', textAlign: "center" }}
            >
              {!districts || districts.length === 0 ? (
                <MenuItem value="">No districts available</MenuItem>
              ) : (
                districts.map((district) => (
                  <MenuItem
                    key={district.District_Id}
                    value={district.District_Id}
                    sx={{ color: '#033538' }}
                  >
                    {district.district_name}
                  </MenuItem>
                ))
              )}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 4" sx={{ marginTop: "auto", textAlign: "left", marginBottom: "10px" }}>
          <Typography sx={{ fontFamily: "poppins", color: "white" }}>
            City Name
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select City</InputLabel>
            <CssSelect
              label="city"
              id="demo-simple-select-outlined"
              size="small"
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              sx={{ width: '100%', textAlign: "center" }}
            >
              {!cities || cities.length === 0 ? (
                <MenuItem value="">No cities available</MenuItem>
              ) : (
                cities.map((city) => (
                  <MenuItem
                    key={city.city_id || city.city_name}
                    value={city || city.city_name} // Assuming city_name is the correct field
                    sx={{ color: '#033538' }}
                  >
                    {city || city.city_name}
                  </MenuItem>
                ))
              )}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 2" sx={{ marginTop: "auto", textAlign: "center" }}>
          <Button onClick={handleCitySubmit}
            sx={{
              border: "1px solid",
              backgroundColor:"#006A71",
              color: "white",
              width: "120px",
              height: "40px",
              borderRadius: "10px",
              fontFamily: "poppins",
            }}
          >
            Save
          </Button>
        </Box>
      </Box>

      <Box xs={1} sx={{ backgroundColor: "#33333" }}>
        <Grid container spacing={1} sx={{ justifyContent: "center" }}>
          <Grid item xs={10}>
            <TableContainer
              component={Paper}
              sx={{
                marginTop: "25px",
                borderRadius: "10px",
              }}
            >
              <Table size="small">
                <TableHead sx={{ backgroundColor: "#006A71" }}>
                  {header.map((n) => (
                    <TableRow key={n.city_id}>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.city_id}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.city_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.state_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.district_name}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.creation_date}
                      </TableCell>
                      <TableCell sx={{ color: "white", borderBottom: 0 }}>
                        {n.action}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableHead>
                <TableBody>
                  {paginatedRows.map((row) => (
                    <TableRow
                      key={row.City_Id}
                      sx={{ backgroundColor: "#033538", marginRight: "30px" }}
                    >
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {row.City_Id}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {row.city_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {row.State_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {row.district_name}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >
                        {row.Creation_Date}
                      </TableCell>
                      <TableCell
                        sx={{ color: "white", border: "1px solid black" }}
                      >

                        <Button
                          variant="contained"
                          sx={{
                             backgroundColor:
                                row.Status === "Active"
                                  ? "#f44336"
                                  : "#4caf50",
                              color: "#ffffff",
                              fontFamily: "poppins",
                              height: "24px",
                              padding: "2px 8px",
                              minWidth: "90px",
                              fontSize: "0.75rem",
                          }}
                          onClick={() => handleModalOpen(row.City_Id, row.Status)}
                          color="error"
                        >
                         {row.Status === "Active"
                                ? "Deactivate"
                                : "Activate"}
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={activeCityList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                sx={{
                  backgroundColor: "#006A71",
                  color: "white",
                }}
              />
            </TableContainer>
          </Grid>
        </Grid>
        <Modal open={isModalOpen} onClose={handleModalClose}>
          <Typography>Are you sure you want to deactivate this city?</Typography>
          <Button onClick={handleConfirm}>Confirm</Button>
          <Button onClick={handleModalClose}>Cancel</Button>
        </Modal>
      </Box>


      <Modal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        title="city"
        action={() => handleDeactivateCity(deactivateId,actionType)}
        actionType={actionType === "Active" ? "Deactivate" : "Activate"}
      />
    </div>
  );
};

export default CityManagement;